import React, {Component} from 'react';
import ListItemBar from "./ListItemBar";
import PuzzleImg from "./PuzzleImg";

export default class ListItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstClick: false,
            maxHeight: 0,
            renderAll: this.props.isOpened
        };

        this.countRows();
        this.propPuzzle = this.props.matchedPuzzles[this.props.matchedPuzzles.length - 1];
    }

    countRows() {
        this.imagesRows = this.props.matchedPuzzles.length === 1
            ? this.props.matchedPuzzles[0].positions
            : this.props.matchedPuzzles.reduce((prevPuzzle, currentPuzzle, i) => {
                if (i === 1) prevPuzzle = prevPuzzle.positions;
                return prevPuzzle + currentPuzzle.positions
            }) / 4;
    }

    countHeight() {
        let firstLi = document.getElementsByClassName('sublist-li')[0];
        let rowHeight = (firstLi ? firstLi.offsetHeight : 89) + 20;
        this.countRows();
        this.setState({
            maxHeight: this.props.isOpened ? (rowHeight * this.imagesRows) : 0
        });
    }

    componentDidMount() {
        this.countHeight();
    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.countHeight();

            this.setState({
                firstClick: true
            });
        }

        if (this.props.isOpened !== prevProps.isOpened) {
            this.setState({renderAll: this.props.isOpened})
        }
    }

    render() {
        let key = this.props.allCommands[this.props.iterator] + '' + this.props.iterator;

        const handleClick = () => {
            let firstLi = document.getElementsByClassName('sublist-li')[0];
            let rowHeight = (firstLi ? firstLi.offsetHeight : 89) + 20;

            this.setState({
                maxHeight: rowHeight * this.imagesRows,
                firstClick: true
            });
        };

        return <li key={key}>
            <ListItemBar opened={this.props.isOpened} key={key + 'info'}
                         onClick={handleClick}
                         puzzle={this.propPuzzle} category={this.props.language[this.props.category]}/>
            <ul key={key} className={'left-menu-sublist'}
                style={{maxHeight: this.state.maxHeight + 'px'}}>
                {this.props.matchedPuzzles.map((matchedPuzzle) =>
                    Array.apply(null, {length: matchedPuzzle.positions}).map((a, i) => {
                        let direction = ['s', 'w', 'n', 'e'][i];
                        const puzzle = <PuzzleImg matchedPuzzle={matchedPuzzle}
                                                  direction={direction}
                                                  setActivePuzzle={this.props.setActivePuzzle}
                                                  alert={this.props.alert}
                                                  hideAlert={this.props.hideAlert}/>;

                        if (key === 'uzupelnij_kat10') {
                            console.log(this.imagesRows);
                        }

                        return <li key={key + i} className={'sublist-li'}>
                            {(this.props.iterator === 0 || this.state.renderAll) ? puzzle : this.state.firstClick && puzzle}
                        </li>;
                    })
                )}
            </ul>
        </li>;
    }
}



// WEBPACK FOOTER //
// ./src/LeftMenu/ListItem.js